<main class="mat-body" *ngIf="test">
    <div class="container progress-bar-wrapper">
        <div class="row">
            <div class="col-12">
                <thr-contract-progress
                    [percent]="50"
                    *ngIf="!contract || !contract.isAdvisoryModelSuitabilityOrGDC()"
                ></thr-contract-progress>
                <thr-contract-progress-advice
                    [percent]="40"
                    *ngIf="contract && contract.isAdvisoryModelSuitability()"
                ></thr-contract-progress-advice>
                <thr-contract-progress-gdc [percent]="40" *ngIf="contract && contract.isAdvisoryModelGDC()"></thr-contract-progress-gdc>
            </div>
        </div>
    </div>

    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="row flex-nowrap justify-content-between align-items-end">
                    <div class="col-auto flex-shrink-1">
                        <ng-container *ngIf="!isSuitability">
                            <h1 class="text-blue mat-display-1 font-weight-bold" [innerHTML]="'test.title'|translate"></h1>
                        </ng-container>
                        <ng-container *ngIf="isSuitability">
                            <h1
                                class="text-blue mat-display-1 font-weight-bold"
                                [innerHTML]="'test.suitability.title'|translate"
                                *ngIf="step === 0 && !showingResume"
                            ></h1>
                            <h1
                                class="text-blue mat-display-1 font-weight-bold"
                                [innerHTML]="'test.suitability.title-block-1'|translate"
                                *ngIf="(step === 0 && showingResume) || (step > 0 && step <= 8)"
                            ></h1>
                            <h1
                                class="text-blue mat-display-1 font-weight-bold"
                                [innerHTML]="'test.suitability.title-block-2'|translate"
                                *ngIf="step > 8 && step <= 12"
                            ></h1>
                            <h1
                                class="text-blue mat-display-1 font-weight-bold"
                                [innerHTML]="'test.suitability.title-block-3'|translate"
                                *ngIf="step > 12"
                            ></h1>
                        </ng-container>
                    </div>
                    <div class="col-auto">
                        <i class="icon-test-natural text-blue"></i>
                    </div>
                </div>
                <hr class="mt-1 mb-0" />
            </div>
        </div>
    </div>

    <ng-container [ngSwitch]="step">
        <ng-container *ngSwitchCase="0">
            <thr-test-start (next)="onNext()" *ngIf="!isSuitability"></thr-test-start>
            <thr-test-start-suitability
                [result]="result"
                [fullResume]="showingFullResume"
                (resume)="showingResume = $event"
                (next)="onResume()"
                (repeat)="onRepeat()"
                *ngIf="isSuitability"
            ></thr-test-start-suitability>
        </ng-container>
        <thr-test-step-circle
            *ngSwitchCase="1"
            [question]="test.questions[0]"
            [step]="'1'"
            [totalSteps]="totalSteps"
            [hideBack]="true"
            (next)="onNext()"
            (back)="onBack()"
        ></thr-test-step-circle>
        <thr-test-step-list
            *ngSwitchCase="2"
            [question]="test.questions[1]"
            [step]="'2'"
            [totalSteps]="totalSteps"
            (next)="onNext()"
            (back)="onBack()"
        ></thr-test-step-list>
        <thr-test-step-list
            *ngSwitchCase="3"
            [question]="test.questions[2]"
            [disabledOptions]="disabledOptions"
            [step]="'3'"
            [totalSteps]="totalSteps"
            (next)="onNext()"
            (back)="onBack()"
        ></thr-test-step-list>
        <thr-test-step-group-list
            *ngSwitchCase="4"
            [question]="test.questions[3]"
            [step]="'4.1'"
            [totalSteps]="totalSteps"
            (next)="onNext()"
            (back)="onBack()"
        ></thr-test-step-group-list>
        <thr-test-step-group-list
            *ngSwitchCase="5"
            [question]="test.questions[3]"
            [from]="5"
            [disabledOptions]="disabledOptions"
            [step]="'4.2'"
            [totalSteps]="totalSteps"
            (next)="onNext()"
            (back)="onBack()"
        ></thr-test-step-group-list>
        <thr-test-step-list
            *ngSwitchDefault
            [question]="test.questions[step - 2]"
            [step]="(step - 1).toString()"
            [totalSteps]="totalSteps"
            [hideBack]="continueResume && step === 9"
            (next)="onNext()"
            (back)="onBack()"
        ></thr-test-step-list>
    </ng-container>
</main>
